const contactRequestEndpoints = {
  CREATE_CONTACT_REQUEST: 'contact-request/contact-requests',
  LIST_CONTACT_REQUESTS: 'contact-request/contact-requests',
  PRESIGNED_URLS_BATCH: 'loopay-media-management/media/presigned-urls/batch',
} as const;

export default contactRequestEndpoints;
